import { useEffect, useState } from "react";

import styled from "@emotion/styled";

import { BasicFlex } from "../../../utils/Common";

import { useFormikContext } from "formik";

import TimelineItem from "../../../utils/utilities/TimelineItem";

import { useTheme, Grid, Card, CardContent, CardHeader, Divider, IconButton, Tooltip, CardActions, speedDialIconClasses, TextField, Button } from "@mui/material";

import { CardBlock, CardBlockHeader, CardBlockContainer, CardSpacer } from "../../../utils/utilities/CardComponents";

import SimpleChip from "../../../utils/utilities/SimpleChip";

import { formatCurrency, formatGenericDate, formatGenericDateTime, capitalize } from "../../../utils/util";

import { useFormData } from "../../../contexts/FormData";

import ErrorMessage from "../../../utils/MuiFields/ErrorMessage";

import RepairTask from "./RepairTask";

// Icons
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import LocalOfferRoundedIcon from '@mui/icons-material/LocalOfferRounded';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import StyleRoundedIcon from '@mui/icons-material/StyleRounded';
import AccountBoxRoundedIcon from '@mui/icons-material/AccountBoxRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';

import DragIndicatorRoundedIcon from '@mui/icons-material/DragIndicatorRounded';

import useIsMobile from "../../../hooks/useIsMobile";


const RepairCard = styled(Card)`
  position: relative;
  overflow-y: auto;
`

const RepairCardHeader = styled(CardHeader)`
  overflow-y: auto;
`

const TopBar = styled(BasicFlex)`
  /* margin-bottom: 1.5rem; */
`

const FileLabel = styled(BasicFlex)`
  width: fit-content;
  padding: 0.3rem .6rem;
  padding-right: .4rem;
  background-color: ${props => props.theme.colors.secondaryFaint};
  border: 1px solid ${props => props.theme.colors.secondary};
  border-radius: 5px;
  color: ${props => props.theme.colors.secondary};
  font-size: 1.2rem;
`;

const DeleteFile = styled.div`
  cursor: pointer;
  margin-left: 1rem;
`

const DragTab = styled(BasicFlex)`
  width: fit-content;
  padding: 0.3rem .6rem;
  background-color: ${props => props.theme.colors.secondaryFaint};
  /* border: 1px solid ${props => props.theme.colors.secondary}; */
  border-radius: 5px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  color: ${props => props.theme.colors.secondary};
  font-size: 1.6rem;
  gap: .5rem;
  padding-right: 1rem;
  cursor: grab;
  
  &:active {
    cursor: grabbing;
  }
`;

const DraggableWrapper = styled(BasicFlex)`
  opacity: ${props => props.$isDragging ? 0.5 : 1};
  transition: opacity 0.2s;
`;

const ActiveRepairs = styled(BasicFlex)`
  max-width: 60rem;
`

const Details = styled.div`
  font-style: italic;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.4;
  margin-top: .5rem;
  /* margin: 1rem 0; */
  background-color: ${props => props.theme.colors.lightBg};
  padding: .5rem 1rem;
  border-radius: 5px;
  /* border: 1px solid ${props => props.theme.colors.border}; */
`

const NoDetails = styled.div`
  font-style: italic;
  font-weight: 500;
  color: ${props => props.theme.colors.lightText};
  line-height: 1.4;
  margin-top: .5rem;
  /* margin: 1rem 0; */
  /* background-color: ${props => props.theme.colors.lightBg}; */
  border-radius: 5px;
  /* border: 1px solid ${props => props.theme.colors.border}; */
`

const getMediaName = (fileName) => {
  let [uuid, index, name] = fileName.split("__");
  return name;
}


const EditDetails = ({ id, setEdit }) => {
  const theme = useTheme();
  const { values, errors, touched, setFieldValue } = useFormikContext() || {};
  let curRepair = values?.repairs?.find((r) => r.repair_task_uuid === id);
  const [ instructions, setInstructions ] = useState(curRepair?.details || "");

  const handleEdit = () => {
    let newRepairs = [...values?.repairs];
    let repair = newRepairs.find((r) => r.repair_task_uuid === id);
    repair.details = instructions;
    setFieldValue('repairs', newRepairs);
    setEdit(false);
  }

  return (
    <BasicFlex dir="column" gap=".5rem" my=".3rem">
      <TextField
        multiline
        fullWidth
        minRows={2}
        name="details"
        value={instructions}
        onChange={(e) => setInstructions(e.target.value)}
        variant="outlined"
        size="small"
      />
      <Button variant="outlined" size="small" onClick={handleEdit}>Update Repair Details</Button>
    </BasicFlex>
  )
}

const Repairs = () => {
  const theme = useTheme();
  const { values, errors, touched, setFieldValue } = useFormikContext() || {};

  const [ edit, setEdit ] = useState(false);

  const [ expand, setExpand ] = useState(false);
  const [ draggedIndex, setDraggedIndex ] = useState(null);

  const { formValues } = useFormData() || {};

  let repairs = values?.repairs || [];

  const { isMobile } = useIsMobile();

  console.log(repairs, "repairs", values);

  const removeMedium = (name) => {
    let media = [...values?.media];
    media = media.filter(file => file?.name !== name);
    setFieldValue('media', media);
  }

  const removeRepair = (index) => {
    let newRepairs = [...repairs];
    newRepairs.splice(index, 1);
    setFieldValue('repairs', newRepairs);
  }

  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    
    if (draggedIndex === null || draggedIndex === dropIndex) {
      setDraggedIndex(null);
      return;
    }

    const newRepairs = [...repairs];
    const [draggedItem] = newRepairs.splice(draggedIndex, 1);
    newRepairs.splice(dropIndex, 0, draggedItem);
    
    setFieldValue('repairs', newRepairs);
    setDraggedIndex(null);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  return ( 
    <Grid size={{xs: 12}}>
      <BasicFlex dir="column" gap="1rem">
        {repairs?.map((repair, index) => {

          let duration = repair.in_house ? `${repair.duration_in_minutes} Min` : `${repair.estimated_time_to_complete} Days`;

          let price = repair.price;

          // console.log(repair, "repair");

          let specialist_name = repair.specialist_name || repair.vendor_name || "Tanya";

          let media = values?.media?.filter(m => {
            let [uuid, index, name] = m?.name?.split('__');
            return uuid === repair.repair_task_uuid
          }) || [];


          let details = [
            { header: "Duration", icon: <AccessTimeIcon color="basic" />, info: duration},
            { header: "Price", icon: <AttachMoneyIcon color="basic" />, info: formatCurrency(price)},
            { header: "Specialist", icon: <ManageAccountsRoundedIcon color="basic" />, info: <SimpleChip label={specialist_name} />},
          ]

          const itemDetails = [
            { header: "Wig Source", icon: <HomeWorkRoundedIcon fontSize='small' color="basic" />, info: capitalize(values.wig_source) },
            { header: "Wig ID", icon: <LocalOfferRoundedIcon fontSize='small' color="basic" />, info: values.wig_id },
          ]

          if (values.wig_source !== "external") {
            itemDetails.push({ header: "SKU", icon: <StyleRoundedIcon fontSize='small' color="basic" />, info: <SimpleChip label={formValues.sku} uc={true} /> });
          }

          if (formValues.wig_sold_on) {
            itemDetails.push({ header: "Sold On", icon: <CalendarMonthRoundedIcon fontSize='small' color="basic" />, info: formatGenericDate(formValues.wig_sold_on, "short") });
          }

          const customer = [
            { header: "Customer", icon: <AccountBoxRoundedIcon fontSize='small' color="basic" />, info: formValues.customer_name },
          ]

          if(repair.status && !["scheduled", "accepted", "cancelled"].includes(repair.status)) {
            return (
              <RepairTask key={index} repair={repair} handleActiveRepair={() => {}} removeRepair={removeRepair} />
            )
          }

        return (
          <DraggableWrapper 
            key={index}
            dir="column"
            $isDragging={draggedIndex === index}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, index)}
          >
            <DragTab 
              draggable 
              onDragStart={(e) => handleDragStart(e, index)}
              onDragEnd={handleDragEnd}
            >
              <DragIndicatorRoundedIcon /> <span>{index + 1}</span>
            </DragTab>
            <RepairCard elevation={4} sx={{width: "100%"}}>
            <RepairCardHeader title={repair.name || repair.repair_name} subheader={repair.description} action={<BasicFlex width="auto" justify="flex-end" gap="2rem">
              <SimpleChip label={repair.in_house ? "In House" : "Vendor"} size="large" palette={repair.in_house ? "success" : "info"} />
              <Tooltip title="Remove Repair"><IconButton color="error" onClick={() => removeRepair(index)}><RemoveCircleOutlineRoundedIcon /></IconButton></Tooltip></BasicFlex>} />
            <Divider />
              <CardContent>
                <BasicFlex gap={!isMobile ? "10rem" : "3rem"} align="flex-start" dir={isMobile ? "column" : "row"}>
                  <CardBlockContainer $gap="1rem">
                  <TopBar>
                    <CardBlockHeader>Repair Details</CardBlockHeader>
                    {/* <IconButton size="small" onClick={() => setExpand(x => !x)} sx={{p: ".1rem"}}>
                      <MoreVertRoundedIcon />
                    </IconButton> */}
                  </TopBar>
                    {details.map((detail, index) => (
                      <CardBlock key={detail.header} {...detail} />
                    ))}

                    {/* {expand ? <>
                      <CardSpacer />

                      <CardBlockHeader>Item Details</CardBlockHeader>
                      {itemDetails.map((detail, index) => (
                        <CardBlock key={detail.header} {...detail} />
                      ))}
                      <CardSpacer />

                      <CardBlockHeader>Customer Details</CardBlockHeader>
                      {customer.map((detail, index) => (
                        <CardBlock key={detail.header} {...detail} />
                      ))}
                    </> : null } */}
                  </CardBlockContainer>
                  <div style={{flexGrow: 1}}>
                    <CardBlockHeader><BasicFlex justify="flex-start" gap=".5rem"><span>Instructions</span> <IconButton size="small"><EditRoundedIcon sx={{fontSize: "1.6rem"}} onClick={() => setEdit(x => !x)} color="secondary" /></IconButton></BasicFlex></CardBlockHeader>
                    {edit ? <EditDetails id={repair?.repair_task_uuid} setEdit={setEdit} /> : <>{repair?.details ? <Details>&ldquo; {repair?.details} &rdquo;</Details> : <NoDetails>No details provided.</NoDetails>}</>}
                  </div>
                </BasicFlex>
              </CardContent>

              <Divider />

              {media?.length ? <CardActions sx={{flexDirection: "column", alignItems: "flex-start", gap: "1rem"}}>
              <BasicFlex gap="1.5rem" justify="flex-start" width="auto">
                {media?.map((medium, index) => <FileLabel key={medium?.name} onClick={() => window.open(medium?.url, "_blank")}>
                  <AttachFileRoundedIcon fontSize="small" />
                  <span>{getMediaName(medium?.name)}</span>
                  <DeleteFile onClick={(e) => {
                      e.stopPropagation();
                      removeMedium(medium?.name)
                    }}>
                    <IconButton size="small" ><HighlightOffRoundedIcon color="secondary" /></IconButton>
                  </DeleteFile>
                </FileLabel>)}
              </BasicFlex>
              </CardActions> : null}
            </RepairCard>
          </DraggableWrapper>
        )}
        )}
      </BasicFlex>
      {touched?.repairs && errors?.repairs && typeof errors?.repairs === "string" && <ErrorMessage error message={errors?.repairs} />}
    </Grid>
  )
};

export default Repairs;